import { gsap, Quart } from 'gsap';

import TemplateContents from './TemplateContents';
import BarbaCustom from './BarbaCustom';
import Header from './Header';
import Footer from './Footer';
import Top from './Top';

export default class extends TemplateContents {
  constructor(param) {
    super(param);

    this.pack.common = this;
    this.pack.barba = new BarbaCustom();
  }

  init() {
    super.init();

    this.lockScroll = true;
    if (this.sw < this.pack.BP) document.documentElement.classList.add('lock');

    //下にスクロールした状態でリロードした時に一番上に戻るようにする処理
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }

  addScrollTarget(target) {
    this.scrollTarget = target;
  }

  removeScrollTarget() {
    this.scrollTarget = undefined;
  }

  addEnterframeTarget(target) {
    this.enterframeTarget = target;
  }

  removeEnterframeTarget() {
    this.enterframeTarget = undefined;
  }

  setVars() {
    super.setVars();
    this.enterframeID;
    this.enterframeIgnoreCnt = 0;

    this.UPDATE_LOAD_COEFF = 0.5;
    this.FPS = 30;
    this.targetInterval = 1000 / this.FPS;
    this.prevTime = Date.now() - this.targetInterval;
    this.lockScroll = false;               //スクロールを無効にするかどうか
    this.waitStartSite = false;
  }

  setDom() {
    super.setDom();
    this.scrollWrapper = document.querySelector('.scroll-wrapper');
    this.barbaWrapper = document.querySelector('.barba-wrapper');
    this.barbaContainer = document.querySelector('.barba-container');

    this.loadingDom = document.querySelector('#loading');

  }

  initEvents() {
    super.initEvents();

    this.bindWheelHandler = this.wheelHandler.bind(this);
    this.bindTouchMoveHandler = this.touchMoveHandler.bind(this);

    this.resizeEvent = navigator.userAgent.match(/(iPhone|iPod|iPad)/)
      ? 'orientationchange'
      : 'resize';

    window.addEventListener('load', this.loadedHandler.bind(this));
    window.addEventListener(
      'DOMContentLoaded',
      this.DOMContentloadedHandler.bind(this)
    );

    window.addEventListener(
      this.resizeEvent,
      this.resizeHandler.bind(this),
      false
    );
    window.addEventListener('scroll', this.scrollHandler.bind(this), {
      passive: false,
    });

    document.addEventListener('wheel', this.bindWheelHandler, {passive: false});
    document.addEventListener('touchmove', this.bindTouchMoveHandler, {passive: false});

    this.resizeHandler();
    this.enterframe();
  }

  wheelHandler(event){
    if (this.lockScroll) {
      const menuElement = event.target.closest('.scrollable');
      if(!menuElement) event.preventDefault();
    }
  }

  touchMoveHandler(event) {
    if (this.lockScroll) {
      const menuElement = event.target.closest('.scrollable');
      if(!menuElement) event.preventDefault();
    }
  }

  DOMContentloadedHandler(event) {
    this.initContainer();
    document.body.style.opacity = 1;
  }

  loadedHandler(event) {}

  initContainer() {
    window.scrollTo(0, 0);

    this.pack.header = new Header();
    this.pack.header.start();

    this.pack.footer = new Footer();
    this.pack.footer.start();

    const namespace = this.barbaContainer.dataset.barbaNamespace;
    this.pack.current = namespace;

    if (namespace === 'top') {
      this.pack.top = new Top();
    }

    this.loadingDom.classList.add('show');

    gsap.delayedCall(1.9, ()=>{
      if(this.pack.hero.canSeek) this.startSite();
      else this.waitStartSite = true;
    });

    this.setCurrent();
  }

  startSite(){
    this.loadingDom.classList.add('hide');
    this.pack.top.start();
  }


  setCurrent() {
    // this.pack.header.setCurrent();
  }

  start() {}

  startLeaveTransition(current) {
    return new Promise((resolve) => {
      gsap.to(this.barbaWrapper, 1, {
        opacity: 0,
        ease: Quart.easeOut,
        onComplete: () => {
          resolve();
        },
      });
    });
  }

  startEnterTransition() {
    gsap.to(this.barbaWrapper, 1, {
      opacity: 1,
      ease: Quart.easeOut,
      onComplete: () => {},
    });
  }

  scrollHandler() {
    this.pack.scrollY = window.scrollY;
    if (this.scrollTarget) this.scrollTarget.scrollHandler();
    this.pack.header.scrollHandler();
  }

  enterframe() {
    this.enterframeID = window.requestAnimationFrame(
      this.enterframe.bind(this)
    );

    if (this.enterframeTarget && this.enterframeTarget.enterframe)
      this.enterframeTarget.enterframe();

    // this.smoothScroll();

    const currentTime = Date.now();
    let updated = false;
    while (currentTime - this.prevTime > this.targetInterval) {
      updated = true;
      this.prevTime += this.targetInterval;
      const now = Date.now();
      const updateTime = now - currentTime;
      if (updateTime > this.targetInterval * this.UPDATE_LOAD_COEFF) {
        // overloaded
        if (this.prevTime < now - this.targetInterval) {
          // do not accumulate too much
          this.prevTime = now - this.targetInterval;
        }
        break;
      }
    }

    if (updated) {
      if (this.enterframeTarget) this.enterframeTarget.enterframeThinOut();
    }

    if (this.enterframeIgnoreCnt % 90 === 0) {
      //間引き処理(1 execution per 90 frames)
      this.resizeHandler();
    }

    //前回のスクロール位置（全ての処理が終わってから代入）
    this.pack.pastScrollY = this.pack.scrollY;

    this.enterframeIgnoreCnt++;
  }

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
